import React, { useContext, useEffect, useState } from 'react';
import DOMPurify from "dompurify";
import { useDispatch, useStore } from 'react-redux';
import { TiArrowForward } from 'react-icons/ti';

import ModalComponent from '../CommonComponents/Modal';
import ComposeEmail from '../ComposeEmail';
import { MdOutlineReply, MdOutlineReplyAll } from 'react-icons/md';
import { AppContext } from '../../context';
import { modifyEmailAsRead, modifyEmailAsReadForMicrosoft } from '../../redux/actions/emailSettings';
import { Loader } from 'rsuite';

const ChildEmailHistory = ({ emailHistory, contacts, onClose, setShow, show, callerAssignedForEmail, setAllUnreadEmailCount, updateParentEmailForNewTag, parentEmail, vendorId }) => {
    const {
        showReplyEmailBox,
        setOldEmailDataInContext,
        setOldEmails,
        oldEmails,
        parentEmailHistories,
        setParentEmailHistories,
        childEmailHistories,
        setChildEmailHistories,
        actionOnEmail,
        setActionOnEmail,
        setParentThread,
        setEmailConversation,
        getRegisteredEmailsHandler,
        setForwardConversation,
    } = useContext(AppContext);

    const store = useStore().getState()
    const { auth: { user } } = store
    const dispatch = useDispatch()

    const [expand, setExpand] = useState(false)
    const [expandChildEmailId, setExpandChildEmailId] = useState(null)
    const [oldEmailData, setOldEmailData] = useState({})
    const [isModifyingLoader, setIsModifyingLoader] = useState(false)
    const [mainChildEmail, setMainChildEmail] = useState({})

    const modifyEmailToRead = async (emailHistory) => {
        let registeredEmailDetails = await getRegisteredEmailsHandler([callerAssignedForEmail])
        let registeredEmailDetail = registeredEmailDetails?.filter((registeredEmail) => registeredEmail?.email?.toLowerCase() === emailHistory?.receiverEmail?.toLowerCase())
        setIsModifyingLoader(true)


        if (emailHistory?.domain === 'google') {
            await dispatch(modifyEmailAsRead({ messageId: emailHistory?.messageId, accessToken: registeredEmailDetail[0]?.accessToken, refreshToken: registeredEmailDetail[0]?.refreshToken, email: registeredEmailDetail[0]?.email }))
                .then(() => {
                    setIsModifyingLoader(false)
                    setChildEmailHistories(prevState => {
                        return prevState?.map(childEmail => {
                            if (childEmail?.messageId === emailHistory?.messageId) {
                                childEmail.isRead = true
                            }
                            return childEmail
                        })
                    })

                    setParentEmailHistories((prevState) => {
                        return prevState?.map((parentEmailHistory) => {
                            if (parentEmailHistory?.messageId === parentEmail?.messageId) {
                                parentEmailHistory.isRead = true
                            }
                            return parentEmailHistory
                        })
                    })
        
                    updateParentEmailForNewTag(parentEmail?.domain, parentEmail?.domain === 'microsoft' ? parentEmail?.conversationId : parentEmail?.threadId, () => { })
                    setAllUnreadEmailCount(prevCount => prevCount - 1)
                })
                .catch((err) => {
                    setIsModifyingLoader(false)
                })
        } else {
            await dispatch(modifyEmailAsReadForMicrosoft({ messageId: emailHistory?.messageId, accessToken: registeredEmailDetail[0]?.accessToken, email: registeredEmailDetail[0]?.email }))
                .then(() => {
                    setIsModifyingLoader(false)
                    setChildEmailHistories(prevState => {
                        return prevState?.map(childEmail => {
                            if (childEmail?.messageId === emailHistory?.messageId) {
                                childEmail.isRead = true
                            }
                            return childEmail
                        })
                    })

                    setParentEmailHistories((prevState) => {
                        return prevState?.map((parentEmailHistory) => {
                            if (parentEmailHistory?.messageId === parentEmail?.messageId) {
                                parentEmailHistory.isRead = true
                            }
                            return parentEmailHistory
                        })
                    })
                    updateParentEmailForNewTag(parentEmail?.domain, parentEmail?.domain === 'microsoft' ? parentEmail?.conversationId : parentEmail?.threadId, () => { })
                    setAllUnreadEmailCount(prevCount => prevCount - 1)

                })
                .catch((err) => {
                    setIsModifyingLoader(false)
                })
        }
    }


    const expandHandler = async (childMailId, emailHistory) => {
        if (!emailHistory?.isRead) {
            await modifyEmailToRead(emailHistory)
        }
        setExpand(!expand)
        setExpandChildEmailId(childMailId)
    }

    const onReplyButtonClick = (e, childEmail, action) => {
        e.stopPropagation();
        setOldEmailData(childEmail)
        setOldEmailDataInContext(childEmail)
        setShow(true)
        setActionOnEmail(action)
        setParentThread(childEmail?.domain === 'google' ? emailHistory?.threadId : emailHistory?.messageId)

        if (childEmail?.domain === "google") {
            let tmpParentEmail = parentEmailHistories?.filter((parent) => parent?.threadId === childEmail?.threadId)
            let tmpChildEmail = childEmailHistories?.filter((child) => child?.threadId === childEmail?.threadId)

            let fullHistories = [...tmpParentEmail, ...tmpChildEmail].sort((a, b) => new Date(a?.sentDate) - new Date(b?.sentDate))?.filter((history) => new Date(history?.sentDate) <= new Date(childEmail?.sentDate))
            setEmailConversation(fullHistories)
            if (action === 'forward') {
                let tmpConversation = fullHistories?.filter(history => new Date(history?.sentDate) < new Date(childEmail?.sentDate))
                setForwardConversation([...tmpConversation, childEmail])
            }
        } else {
            let tmpParentEmail = parentEmailHistories?.filter((parent) => parent?.conversationId === childEmail?.conversationId)
            let tmpChildEmail = childEmailHistories?.filter((child) => child?.conversationId === childEmail?.conversationId)

            let fullHistories = [...tmpParentEmail, ...tmpChildEmail].sort((a, b) => new Date(a?.sentDate) - new Date(b?.sentDate))?.filter((history) => new Date(history?.sentDate) <= new Date(childEmail?.sentDate))
            setEmailConversation(fullHistories)
            if (action === 'forward') {
                let tmpConversation = fullHistories?.filter(history => new Date(history?.sentDate) < new Date(childEmail?.sentDate))
                setForwardConversation([...tmpConversation, childEmail]?.sort((a, b) => new Date(b?.sentDate) - new Date(a?.sentDate)))
            }
        }

        setOldEmails(childEmail)
    }

    const closeHandler = () => {
        onClose("check", showReplyEmailBox)
    }


    useEffect(() => {
        setMainChildEmail(emailHistory)
    }, [])

    return (
        <div key={mainChildEmail?.messageId} className='border flex-column rounded p-3 mb-2  position-relative' style={{ height: 'auto', width: 900, cursor: 'pointer' }} onClick={() => { expandHandler(mainChildEmail?.messageId, mainChildEmail) }} >
            <div className='d-flex justify-content-between'>
                <h3 className='fw-bold' style={{ color: '#214466' }}>{mainChildEmail?.subject?.toUpperCase()}</h3>
                {
                    !mainChildEmail?.hideActionBtn && <div className='d-flex align-items-center gap-2'>
                        <button className='email_action_button' title='Reply' onClick={(e) => { onReplyButtonClick(e, mainChildEmail, 'reply') }}><MdOutlineReply size={18} /></button>
                        <button className='email_action_button' title='Reply All' onClick={(e) => { onReplyButtonClick(e, mainChildEmail, 'replyAll') }}><MdOutlineReplyAll size={18} /></button>
                        <button className='email_action_button' title='Forward' onClick={(e) => { onReplyButtonClick(e, mainChildEmail, 'forward') }}><TiArrowForward size={18} /></button>
                    </div>
                }
            </div>
            <div className={`d-flex ${!expand && 'column-gap-4'}`}>
                <p className='fw-bold fs-5' style={{ color: '#214466', letterSpacing: 1 }}>{mainChildEmail?.receivedDate} ( {mainChildEmail?.timeSpan} )</p>
                {
                    !expand && (<p className='fw-bold m-0 fs-5' style={{ color: '#214466', letterSpacing: 1 }} >{mainChildEmail?.senderEmail} {' -> '} {mainChildEmail?.receiverEmail}</p>)
                }
            </div>
            {
                !expand && (
                    mainChildEmail?.body && mainChildEmail.body.length > 100
                        ? <p>{`${mainChildEmail?.body?.substring(0, 100)}...`}</p>
                        : <p className='fs-4'>{mainChildEmail?.body}</p>
                )
            }
            {isModifyingLoader ? <div className='d-flex justify-content-center'><Loader /></div> : expand && <>
                <div
                    dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(mainChildEmail?.mainBody),
                    }}
                    style={{ border: "1px solid #ccc", padding: "10px", fontSize: 16 }}
                    className='mt-3 rounded'
                >
                </div>
            </>}
            {show && (
                <>
                    <ModalComponent modalTitle='' open={showReplyEmailBox} handleClose={() => { setShow(false) }} dialogClassName='px-5 create-new-contact-modal-dialog'>
                        <ComposeEmail
                            onClose={closeHandler}
                            contacts={contacts}
                            componentFor={''}
                            actionOnEmail={actionOnEmail}
                            setShow={setShow}
                            oldEmails={oldEmails}
                            activeTab={'notes'}
                            vendorId={vendorId}
                        />
                    </ModalComponent>
                </>
            )}
            {!mainChildEmail?.isRead ? <span class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger fs-5">
                new
            </span> : null}
        </div>
    )
}



export default ChildEmailHistory;